'use client'
import { Autocomplete, TextField } from '@mui/material'
import { FieldValue } from '@/types'
import { memo } from 'react'

type MultiSelectFieldProps = {
  id: string
  value: FieldValue
  options: string[]
  placeholder?: string
  onChangeHandler: (val: FieldValue, id: string) => void
}

const MultiSelectField = ({ id, value, options, placeholder, onChangeHandler }: MultiSelectFieldProps) => {
  return (
    <Autocomplete
      fullWidth
      size="small"
      value={(value || []) as string[]}
      onChange={(_, newValue: string[] | null) => {
        onChangeHandler(newValue, id)
      }}
      multiple
      options={options}
      freeSolo
      renderInput={(params) => (
        <TextField
          placeholder={placeholder}
          {...params}
          hiddenLabel
          size="small"
        />
      )}
    />
  )
}

export default memo(MultiSelectField)
